// extracted by mini-css-extract-plugin
export default {"wrapper":"k2-z","play":"l2-z"};